import type {
  SaasMigrationSetting,
  SaasTrial,
} from '@evenfinancial/finance-client';

import { client } from '../client';

export type SaasSubscriptionFull = any;

export const getSaasUserTrial = async () =>
  client.get<SaasTrial>('/finance/saas/userTrial').then(({ data }) => data);

export const getSaasSubscriptionFull = async () =>
  client
    .get<SaasTrial>('/finance/saas/subscription-full')
    .then(({ data }) => data);

export const getSaasMigrationSettings = async () =>
  client
    .get<SaasMigrationSetting>('/supply_migration/')
    .then(({ data }) => data);
